import React from 'react';
import './OnboardingProgressBar.modules.css';

const OnboardingProgressBar = ({ currentStep, totalSteps }) => {
    const progressPercent = ((currentStep / (totalSteps) )) * 100;

    return (
        <div className="progress-bar-container">
            <div className="progress-bar">
                <div
                    className="progress-bar-fill"
                    style={{ width: `${progressPercent}%` }}
                />
            </div>
            <div className="progress-steps">
                {Array.from({ length: totalSteps }, (_, index) => (

                    <>
                        <div
                            key={index}
                            className={`progress-step ${currentStep >= index + 1 ? 'completed' : 'Uncompleted'
                                }`}
                        />


                        {/* <div >     {index + 1}</div> */}
                    </>

                ))}

            </div>
        </div>
    );
};

export default OnboardingProgressBar;